import React from 'react';
import {withRouter} from 'react-router-dom';

import Modal from '../../../shared/components/modal';

import './blog-email-form.less';


let blogEmailFormOpenModalStyle = {
    position:'fixed',
    width: '40%',
    top:'30%',
    left: '50%',
    transform: 'translate(-50%, -30%)',
    maxWidth: 1600,
    backgroundColor: 'rgba(0,0,0,0)'
};

class BlogEmailForm extends React.Component{

    constructor(){
        super();
        this.iframeRef = React.createRef();
        this.state = {
            iframeLoaded: false
        }
        this.iframeEventHandler = this.iframeEventHandler.bind(this);
    }

    static blogEmailFormSubmitLink = 'us:hho:optly:campaign:newsletter_submit_button_success';
    static blogEmailFormModalSrc = "https://cloud.store.hp.com/newsletter_pop-up_form";
    static blogEmailFormEventUniqueIdentifier = { forBlogEmailForm: true };

    sendMessageToIframe(){
        try{
            this.iframeRef.current.contentWindow.postMessage( { url: window.location.href, submitId: BlogEmailForm.blogEmailFormSubmitLink }, BlogEmailForm.blogEmailFormModalSrc);
        }catch(e){}
    }

    iframeEventHandler(event){
        if(event && event.data === 'Close'){
            this.props.handleClose();
        }
    }

    componentDidMount(){
        try{
            window.addEventListener('message', this.iframeEventHandler);
        }catch(e){ }
    }

    componentWillUnmount(){
        try{
            window.removeEventListener('message', this.iframeEventHandler);
        }catch(e){ }
    }

    static getDerivedStateFromProps(nextProps, prevState){
        return nextProps && !nextProps.isOpen ? (
            {
                iframeLoaded: false
            }
        ) : null;
    }

    componentDidUpdate(prevProps, prevState){
        let { iframeLoaded: prevIframeLoaded } = prevState || {};
        let { iframeLoaded } = this.state;
        let { match : {url : prevUrl} = {},
              isOpen : prevIsOpen } = prevProps || {};
        let { match : {url} = {},
              isOpen } = this.props;

        if( iframeLoaded && !prevIframeLoaded ){
            this.sendMessageToIframe();
        }
        else if( prevUrl !== url ){
            this.props.handleClose();
        }
    }

    render(){
        let {handleClose, isOpen, match : { url } = {}} = this.props;
        return (
            isOpen ? (
            <Modal  isOpen={isOpen} className="blog-email-modal" wrapperClassName="blog-email-modal-wrapper"
                    closeModal={handleClose} openStyle={blogEmailFormOpenModalStyle} >
                <iframe ref={this.iframeRef} id="blog-email-iframe" className="blog-email-modal-iframe" src={BlogEmailForm.blogEmailFormModalSrc} width="100%" 
                        onLoad={()=>this.setState({iframeLoaded: true})}
                        height="540" frameBorder="0" marginWidth="0" marginHeight="0" scrolling="no"/>
            </Modal>
            ) : null
        );
    }
}

export default withRouter(BlogEmailForm);
